import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useAuth } from "react-oidc-context";
import { getUserId } from "utils/getUserId";
import { convertToLetters } from "utils/convertToLetters";
import Avatar from "components/Avatar";

const CreatedByCell: FC<Props> = ({ element }) => {

  const auth = useAuth();
  const userId = getUserId(auth.user!);

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.stack}`}>
        <div className={styles.sender}>
          {" "}
          {element.CreatedByUserId !== userId && (
            <Avatar className={styles.avatar}>
              {convertToLetters(element.CreatedByUserLabel)}
            </Avatar>
          )}
          {element.CreatedByUserId !== userId
            ? `${element.CreatedByUserLabel}`
            : ""}
        </div>
      </div>
    </div>
  );
};

export default CreatedByCell;
